import { PlannerConfig, ConfigOptions, FeatureConfig } from '../@types';
import elvarliCatalog from '@inter-ikea-storagetwo/elvarli/dist/rangeConfig/catalog.json';
import elvarliTemplate from '@inter-ikea-storagetwo/elvarli/dist/rangeConfig/template.json';
import platform from 'rangeConfig/shared/utils/platform';
import { elvarliComponentResolver } from '@inter-ikea-storageone/range-elvarli';
import { plannerComponentResolver } from '@inter-ikea-storageone/range';
import interiors from './productGroups/interiors';
import MeasureAction from 'components/SceneMenu/actions/MeasureAction';
import sections from './productGroups/sections';
import { StabilityValidation } from 'rangeConfig/shared/features/StabilityValidation/StabilityValidation';
import sprToVpcMap from '@inter-ikea-storageone/range-elvarli/data/spr2vpc.json';
import { DistanceMeasurementFeature } from 'rangeConfig/shared/features/DistanceMeasurementFeature';
import { MultiWallSeeThroughFeature } from 'rangeConfig/shared/features/MultiWallSeeThroughFeature';
import elvarliLandingPageConfig from './elvarliLandingPageConfig';

const defaultAssetsPath = '/assets/';
const assetsPath = import.meta.env.REACT_APP_ASSETS_PATH || defaultAssetsPath;

const features = (): { mobile: FeatureConfig[]; desktop: FeatureConfig[] } => {
  return {
    mobile: [
      { id: 'MultiwallSeeThroughFeature', feature: MultiWallSeeThroughFeature },
      { id: 'StabilityValidation', feature: StabilityValidation }
    ],
    desktop: [
      { id: 'MultiwallSeeThroughFeature', feature: MultiWallSeeThroughFeature },
      { id: 'StabilityValidation', feature: StabilityValidation },
      { id: 'DistanceMeasurement', feature: DistanceMeasurementFeature }
    ]
  };
};

const productGroups: any = () => {
  const productGroups = {
    desktop: [sections, interiors],
    mobile: [sections, interiors]
  };

  return productGroups[platform].map(group => group());
};

const sceneActions = {
  desktop: [MeasureAction],
  mobile: [MeasureAction]
};

const elvarliPlannerConfig = (options?: ConfigOptions): PlannerConfig => {
  return {
    productCatalogs: [
      {
        name: 'elvarli',
        catalog: elvarliCatalog,
        template: elvarliTemplate,
        assetsPath
      }
    ],
    sprToVpcMap,
    componentResolvers: [plannerComponentResolver, elvarliComponentResolver],
    featureToggles: [],
    productGroups: productGroups(options),
    features: features()[platform],
    cameraBehavior: () => {},
    sceneActions: sceneActions[platform],
    landingPageConfig: elvarliLandingPageConfig
  };
};

export default elvarliPlannerConfig;
